import React from "react";
import moment from "moment";

// Scénario B status pills (quote states, stock, "Devis à confirmer") — the
// storyboard's palette (docs/storyboard/scenario-b).
const TONES = {
  teal: { background: "#59a8c433", color: "#14748e" },
  red: { background: "rgba(204,31,8,0.12)", color: "#cc1f08" },
  grey: { background: "#eeeeee", color: "#666666" },
  copper: { background: "#feefd8", color: "#050505" },
  orange: { background: "#feefd8", color: "#c9762e" },
  green: { background: "#e3f4e8", color: "#2e7d32" },
  chip: { background: "#e7f2f5", color: "#14748e" },
};

/** Quote state → raw i18n label + tone. Legacy quotes without state = draft. */
export const QUOTE_STATES = {
  draft: { label: "Draft", tone: "grey" },
  sent: { label: "Sent", tone: "teal" },
  accepted_by_customer: { label: "Accepted by the customer", tone: "teal" },
  accepted: { label: "Accepted", tone: "teal" },
  unavailable: { label: "Unavailable — to edit", tone: "red" },
  refused: { label: "Refused", tone: "grey" },
  expired: { label: "Quote expired", tone: "grey" },
};
export const quoteStateOf = (quote) => quote?.state || "draft";

export const formatEuro = (value) =>
  `${(Number(value) || 0).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;

/** "En stock — dépôt Lyon · SN …" / "En approvisionnement — arrivée 04/11". */
export const unitLabel = (unit, t) => {
  if (unit.status === "in-stock") {
    return unit.depot && unit.serialNumber
      ? t("In stock — depot {{depot}} · SN {{sn}}", {
          depot: unit.depot,
          sn: unit.serialNumber,
        })
      : t("In stock");
  }
  return unit.arrivalDate
    ? t("In supply — arrival {{date}}", {
        date: moment(unit.arrivalDate).format("DD/MM"),
      })
    : t("Supply in progress");
};
export const unitTone = (unit) => (unit.status === "in-stock" ? "green" : "orange");

export const failureLabel = (failure, t) =>
  failure.serialNumber
    ? t("Unavailable — SN {{sn}} sold on {{date}}", {
        sn: failure.serialNumber,
        date: failure.soldOn ? moment(failure.soldOn).format("DD/MM") : "-",
      })
    : t("No unit available");

const QuotePill = ({ tone = "grey", dot, onClick, children }) => (
  <span
    onClick={onClick}
    className={onClick ? "pointer" : undefined}
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      height: 22,
      padding: "0 10px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      whiteSpace: "nowrap",
      ...TONES[tone],
    }}
  >
    {dot && (
      <span style={{ width: 8, height: 8, borderRadius: "50%", background: dot }} />
    )}
    {children}
  </span>
);

export default QuotePill;
